import { newConfig } from '../config';
import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;

export default class GroupCompanyService {
  constructor(client) {
    this.client = client;
  }

  async getGroupCompanies({ companyId }) {
    const response = await this.client.get(
      `${newConfig.services.proxy.url}${newConfig.services.proxy.core}/${v2}/companies/${companyId}/group-companies`
    );
    return response.data;
  }
}
